import React from "react";
import { Modal, Typography, Alert, Divider } from "antd";

import "./LocationAccess.css"; // Custom CSS for styling

const { Text } = Typography;

const VariableAccess = ({ isVisible, handleCancel }) => {
  return (
    <Modal
      className="location-modal"
      title={<div className="modal-title">Variables Usage</div>}
      open={isVisible}
      footer={null}
      centered
      width={720}
      onCancel={handleCancel}
    >
      <div className="modal-content">
        <Alert
          description={
            <>
              <Text className="text-loc-modal">
                The listed variables can be used in the template summary within
                double curly brackets (e.g., <Text code>{`{{full_name}}`}</Text>
                ), and they are case-sensitive.
              </Text>
              <Divider style={{ margin: "10px 0" }} />

              <Text className="text-loc-modal">
                1. Variables in <Text style={{ color: "blue" }}>blue</Text> have
                not been used in the template.
              </Text>
              <Divider style={{ margin: "5px" }} />

              <Text className="text-loc-modal">
                2. Variables in <Text style={{ color: "green" }}>green</Text>{" "}
                have been used at least once in the template.
              </Text>
              <Divider style={{ margin: "5px" }} />

              <Text className="text-loc-modal">
                3. Click on any variable to insert it into the text editor.
              </Text>
            </>
          }
          type="info"
          showIcon
        />
      </div>
    </Modal>
  );
};

export default VariableAccess;
